import { Component, OnInit, OnDestroy } from "@angular/core";
import { SubscriptionService, InteractivesService } from "../../api/services";
import {
  UserState,
  US_ReportExport,
  SubInteractReportExports,
  US_Interactive,
} from "../../api/models";
import { Router } from "@angular/router";
import { GlobalApp } from "../../tools/global";
import { ConfirmDialogComponent } from "../../dialogs/confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import {
  ReportExportDialogData,
  ReportExportDialogComponent,
} from "../../dialogs/report-export-dialog/report-export-dialog.component";
import { DialogResultType } from "../../dialogs/DialogResult";
import { UserStateEx } from "../../api/models-ex/user-state-ex";
import { Subscription } from "rxjs";

@Component({
  selector: "app-interactive",
  templateUrl: "./report-exports.component.html",
})
export class ReportExportsComponent implements OnInit, OnDestroy {
  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false
  };
  userStateSubscription: Subscription = null;

  public refreshTimer: any = null;
  public loadingData = false;

  constructor(
    private subscriptionService: SubscriptionService,
    private interactiveService: InteractivesService,
    private app: GlobalApp,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      }
    });
  }

  loadUserState() {
    this.loadingData = true;
    this.app.refreshUserState(this.subscriptionService);
  }

  ngOnInit() {
    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      this.userState = userState;

      this.userState.interactives.sort((left, right): number => {
        if (left.interactName < right.interactName) return -1;
        if (left.interactName > right.interactName) return 1;
        return 0;
      });

      this.userState.interactives.forEach((interactive) => {
        interactive.currentReports.sort((left, right): number => {
          if (left.name < right.name) return -1;
          if (left.name > right.name) return 1;
          return 0;
        });
      });

      this.loadingData = false;
    });

    this.refreshTimer = setInterval(() => {
      this.loadUserState();
    }, 20000);

    this.loadUserState();
  }

  ngOnDestroy() {
    if (this.userStateSubscription) {
      this.userStateSubscription.unsubscribe();
    }
    clearInterval(this.refreshTimer);
  }

  downloadReportExport(selectedExport: SubInteractReportExports): boolean {
    if (selectedExport.status === 1) {
      this.interactiveService
        .interactivesGetReportExportDownloadUrl(
          selectedExport.subInteractReportExportId
        )
        .subscribe((resultUrl) => {
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.setAttribute("style", "display: none");
          a.href = resultUrl;
          a.download = selectedExport.fileId + "." + selectedExport.fileExt;
          a.click();
          window.URL.revokeObjectURL(resultUrl);
          a.remove();
        });
    }
    return false;
  }

  deleteReportExport(selectedExport: SubInteractReportExports): boolean {
    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Delete",
      "Are you sure you want to delete this report?"
    ).subscribe((result) => {
      if (result.ResultType == DialogResultType.Ok) {
        this.interactiveService
          .interactivesDeleteReportExport({
            subInteractReportExportId: selectedExport.subInteractReportExportId,
            userId: -1
          })
          .subscribe((result) => {
            this.loadUserState();
          });
      }
    });

    return false;
  }

  editReportExport(
    interactive: US_Interactive,
    selectedExport: US_ReportExport
  ): boolean {
    if (selectedExport !== null && selectedExport.owner) {
      const dialogData: ReportExportDialogData = {
        subInteractReportExportId: selectedExport.subInteractReportExportId,
        description: selectedExport.description,
        isNewExport: false,
        name: selectedExport.name,
        shareState: UserStateEx.getReportExportShareState(
          this.userState,
          selectedExport
        ),
        subscriptionId: selectedExport.subscriptionId,
        userSubscriptions: interactive.subscriptionHeaders,
        exportFormat: "",
      };

      const dialogRef = this.dialog.open(ReportExportDialogComponent, {
        width: "600px",
        data: dialogData,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (
          result !== null &&
          result.ResultType !== null &&
          result.ResultType === DialogResultType.Ok
        ) {
          const ResultData = result.ResultData as ReportExportDialogData;
          this.interactiveService
            .interactivesUpdateReportSharing({
              SubInteractReportExportId: ResultData.subInteractReportExportId,
              updateSharingStatus: UserStateEx.getSharingStatus(
                ResultData.shareState
              ),
            })
            .subscribe((shareResult) => {
              this.loadUserState();
            });
        }
      });
    }
    return false;
  }
}
